import PropTypes from "prop-types";
import Client from "./Customer";
import Parent from "./Parent";
import { createField, getEntityTypes, getEntityDefaults } from "./utils";

const ImmigrationPersonalInfo = {
    fileNo: createField(PropTypes.string, ""),
    receiptNumber: createField(PropTypes.string, ""),
    prefix: createField(PropTypes.string, ""),
    consecutive: createField(PropTypes.number, 0),
    client: createField(PropTypes.shape(getEntityTypes(Client)), getEntityDefaults(Client)),
    petitioner: createField(PropTypes.string, ""),
    petitionerANo: createField(PropTypes.string, ""),
    petitionerNatCert: createField(PropTypes.string, ""),
    petitionerSSN: createField(PropTypes.string, ""),
    startDate: createField(PropTypes.instanceOf(Date), null),
    dateOfEntry: createField(PropTypes.instanceOf(Date), null),
    placeOfEntry: createField(PropTypes.string, ""),
    howEntered: createField(PropTypes.string, ""),
    type: createField(PropTypes.shape({}), null),
    srcNo: createField(PropTypes.string, ""),
    alienRegistrationNo: createField(PropTypes.string, ""),
    status: createField(PropTypes.shape({}), null),
    notes: createField(PropTypes.string, ""),
    courtLocation: createField(PropTypes.string, ""),
    courtDate: createField(PropTypes.instanceOf(Date), null),
    fileLocation: createField(PropTypes.shape({}), null),
    parent: createField(PropTypes.shape(getEntityTypes(Parent)), getEntityDefaults(Parent)),
    parentId: createField(PropTypes.number, null),
    trnFlowId: createField(PropTypes.number, null),
    supplementDeadline: createField(PropTypes.instanceOf(Date), null),
    otherDeadline: createField(PropTypes.instanceOf(Date), null),
    individualCourtDate: createField(PropTypes.instanceOf(Date), null),
    assigneeUser: createField(PropTypes.shape({}), null),
    workStatus: createField(PropTypes.string, "casePreparation"),
    clientHasDualCitizenship: createField(PropTypes.bool, null, "bool"),
    clientHasEnteredMultipleTimesToUsa: createField(PropTypes.bool, null, "bool"),
};

export default ImmigrationPersonalInfo;

// Set of date-type fields that might be used for calendar event purposes
export const getEventFields = () => [
    { field: "courtDate", label: "Master Court Date" },
    { field: "individualCourtDate", label: "Individual Court Date" },
    { field: "supplementDeadline", label: "Supplement Deadline" },
];
